import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import NbcFilterImage from "component/product/extended-definition/NbcFilterImage";
import HideIf from "util/HideIf";
import { useState } from "react";
import styles from "./new-product-filter.module.scss";

function FilterSidebarMenu(props: any) {
  const {
    filterKey, title, isDefaultexpanded, renderList, className = "",
  } = props;

  const [expanded, setExpanded] = useState(isDefaultexpanded);

  return (
    <div className={`${styles.sidebar_filter} ${className}`}>
      <PAText
        component="h3"
        onClick={() => setExpanded(!expanded)}
        fontSize={FONT_SIZE[2]}
        color="black"
        className="d-flex justify-content-between align-items-center m-0"
      >
        <div className="d-flex align-items-center text-capitalize">{title}</div>
        <span className={styles.expand_btn}>
          <NbcFilterImage filterKey={filterKey} size={35} showCommonLabel />
          <span className={styles.expand_icon}>{expanded ? "-" : "+"}</span>
        </span>
      </PAText>

      <HideIf show={expanded}>
        <div className="p-t-20">
          {renderList()}
        </div>
      </HideIf>
    </div>
  );
}

export default FilterSidebarMenu;
